export const es = {
    // Language
    en: 'Inglés',
    es: 'Español',

    // App
    app_loading: 'Cargando. Por favor espera...',

    // Routes
    route_login: 'Iniciar sesión',
    route_settings: 'Ajustes',
    route_forgot_pwd: 'Olvidó contraseña',
    route_register: 'Registro',
    route_reset_pwd: 'Restablecer la contraseña',

    // Login.vue
    login_txt: 'Inicie sesión en su cuenta',
    login_txt_usr: 'Nombre de usuario',
    login_placeholder_usr: 'Ingrese su nombre de usuario',
    login_txt_pwd: 'Contraseña',
    login_placeholder_pwd: 'Ingresa tu contraseña',
    login_txt_email: 'Email',
    login_placeholder_email: 'Introduce tu correo electrónico',
    login_btn_login: 'Iniciar sesión',
    login_btn_login_google: 'Iniciar sesión con Google',
    login_msg_login_successful: 'Inicio de sesión correcto',
    login_msg_wrong_usr_or_pwd: 'Nombre de usuario o contraseña incorrectos',
    login_msg_login_error: 'Error al iniciar sesión',
    login_msg_login_error_no_google_session: 'Primero inicia sesión en Google y luego regresa. Gracias.',
    login_msg_confirm_email: 'Confirma tu correo electrónico',
    login_msg_missing_org: 'El usuario no está asignado a ninguna organización.',
    login_msg_disabled: 'El usuario está deshabilitado',
    login_msg_approve_email: 'Su correo electrónico aún no está aprobado. Por favor espere la aprobación ',
    login_msg_lockout: 'Su cuenta está bloqueada durante 15 minutos',
    login_chk_remember_me: 'Recuérdame',
    login_txt_new_acc: 'Crear una nueva cuenta',
    login_txt_forgot_pwd: '¿Olvidó su contraseña?',
    login_accepted_invite: 'Has aceptado con éxito la invitación.Por favor Iniciar sesión.',
    login_invalid_invite_token: 'Token inválido o caducado. Solicite un nuevo enlace de invitación.',

    // ForgotPwd.vue
    forgot_pwd_title: '¿Olvidó su contraseña?',
    forget_pwd_bnt_send_reset_link: 'Enviar enlace de restablecimiento de contraseña',
    forget_pwd_msg_reset_link_sent: 'Enlace de restablecimiento de contraseña enviado a su correo electrónico',
    forgotten_pwd_msg_error: 'Error al enviar el enlace de restablecimiento de contraseña',
    forgot_pwd_send_rst_link_to: 'Send me a reset link to:',
    forgot_pwd_invalid_token: 'Restablecer enlace expiró. Enviando nuevo enlace en correo electrónico ...',

    // Forms in general
    form_msg_field_required: 'Se requiere campo',
    form_msg_field_required_v2: '{0} es obligatorio',
    form_msg_min_length: 'El campo debe tener al menos {0} letras.',
    form_msg_email: 'El correo electrónico es invalido',
    form_msg_pass_match: 'Las contraseñas deben coincidir',
    form_msg_strong_pass: `La contraseña debe tener una letra, un número,
                           un carácter especial y al menos 8 caracteres`,
    form_txt_back_to_login: 'Volver al inicio de sesión',
    form_txt_or_sign_up: 'Or sign up',
    form_msg_terms_agree: 'Acepto',
    form_msg_terms: 'Por favor, acepte los términos de uso',
    form_msg_google_analytics: 'Identificación incorrecta de Google Analytics',

    // Register.Vue
    register_txt_title: 'Registro de HexIQ',
    register_txt_firstname: 'Nombre',
    register_placeholder_firstname: 'Ingrese su nombre',
    register_txt_lastname: 'Apellido',
    register_placeholder_lastname: 'Ingrese su apellido',
    register_txt_companyname: 'Nombre de la empresa',
    register_txt_company_classification: 'Clasificación de la empresa',
    register_placeholder_companyname: 'Ingrese el nombre de su compañía',
    register_txt_email: 'Correo electrónico',
    register_placeholder_email: 'Ingrese su correo electrónico',
    register_txt_pass: 'Contraseña',
    register_placeholder_password: 'Ingrese su contraseña',
    register_txt_conf_pass: 'Confirmar contraseña',
    register_placeholder_conf_pass: 'Confirme su contraseña',
    register_btn_register: 'Registrarse',
    register_btn_register_google: 'Registrarse en Google',
    register_msg_email_exists: 'Correo electrónico ya registrado',
    register_msg_reg_successful: 'Registro completo. Por favor confirme su dirección de correo electrónico',
    register_msg_error: 'Error al registrarse',
    register_msg_invited_usr: 'Has aceptado con éxito una invitación. Por favor regístrese para crear una cuenta',
    registration_txt_consent: 'Al elegir registrarse, usted acepta el ',
    registration_txt_consent_and: 'y',
    registration_txt_privacy_policy: 'Política de privacidad',
    registration_txt_software_agreement: 'Licencia y Términos de cuenta',

    // Confirm email
    confirm_email_success: 'Correo electrónico confirmado. Inicie sesión.',
    confirm_email_failed: ' Error en la configuración del correo electrónico. ',
    confirm_email_btn_resend: 'Reenviar email.',
    confirm_email_msg_ok: 'Reenviar correo electrónico. Verifique su cliente de correo electrónico. ',
    confirm_email_msg_error: 'Error al reenviar correo electrónico',

    // Reset password
    set_pwd_title: 'Stablece tu contraseña',
    reset_pwd_title: 'Restablece tu contraseña',
    reset_pwd_btn_reset: 'Restablecer contraseña',
    reset_pwd_btn_reset_text: 'Restablece',
    reset_pwd_new_password: 'Nueva contraseña',
    reset_pwd_msg_success: 'Correcto, restablecimiento de contraseña',
    reset_pwd_msg_error: 'Error al restablecer contraseña',
    reset_pwd_msg_invalid_token: 'Restablecer enlace caducado',

    // MainHeader.Vue
    mainheader_settings: 'Ajustes',
    mainheader_admin: 'Admin',
    mainheader_logout: 'Cerrar sesión',
    mainheader_contact_support: 'Contactar con soporte',
    mainheader_marketmap: 'Mapa del mercado',
    mainheader_filter: 'Filtro',
    mainheader_search: 'Buscar',
    mainheader_mapbuilder: 'Constructor de mapas',
    mainheader_mainmenu: 'Menú principal',
    mainheader_account_settings: 'Configuración de la cuenta',
    mainheader_organization: 'Organización',
    mainheader_subscription_name: 'Suscripción {0}',
    mainheader_account: 'Cuenta',
    mainheader_medical: 'Médica',
    mainheader_manage_subscriptions: 'Suscripciones',
    mainheader_manage_invoices: 'Facturas y recibos',
    mainheader_data_issues: 'Informar sobre problemas con los datos del pagador',

    // NotificationCenter.vue
    notifications_title: 'Notificaciones',
    notifications_close: 'Cerrar notificaciones',
    notifications_unread: 'No leídas',
    notifications_all: 'Todas',
    notifications_select_all: 'Seleccionar todo',
    notifications_mark_read: 'Marcar como leída',
    notifications_mark_all_read: 'Marcar todo como leído',
    notifications_type: 'Tipo',
    notifications_type_all: 'Todas',
    notifications_type_tickets: 'Tickets',
    notifications_type_downloads: 'Descargas',
    notifications_type_info: 'Información',
    notifications_empty_unread: 'Estás al día',
    notifications_empty_all: 'Aún no hay notificaciones',
    notifications_open_tickets: 'Ver tickets',
    notifications_open_downloads: 'Ir a Descargas',
    notifications_open_info: 'Abrir',
    notifications_dismiss: 'Descartar',
    notifications_now: 'ahora',

    // Settings.vue
    settings_title: 'Ajustes',
    settings_users_title: 'Usuarios',
    settings_traffic_sources_title: 'Fuentes de tráfico en',
    settings_delete_traffic_source_title: 'Eliminar fuente de tráfico',
    settings_user: 'Usario',
    settings_email: 'Email',
    settings_role: 'Papel',
    settings_org: 'Organización',
    settings_lang: 'Idioma',
    settings_btn_add_org: 'Agregar organización',
    settings_btn_back: 'Cerrar',
    settings_btn_connect_google_analytics: 'Conectar datos de Google Analytics',
    setting_current_org: 'Corriente:',
    setting_other_org: 'Otro:',
    setting_switch_org_title: 'Cambiar organización',
    setting_switch_org: '¿Estás seguro de que quieres cambiar?',
    setting_delete_org_title: 'Eliminar organización',
    setting_delete_org: '¿Está seguro de que desea eliminar?',
    setting_status: 'Estado',
    setting_revoke: 'Revocar',
    setting_resend_invite: 'Reenviar invitación',
    setting_active: 'Activate',
    setting_make_admin: 'Dar derechos de administrador',
    setting_revoke_admin: 'Revocar derechos de administrador',
    setting_suspend: 'Suspender',
    setting_is_admin: 'Es administrador',
    setting_show_details: 'Mostrar detalles',

    // Admin.vue
    admin_title: 'Administración',

    // Error.vue
    error_txt: 'Error',
    error_unsupported_browser: 'Navegador no compatible',
    error_unsupported_browser_txt: 'Para una mejor experiencia, utilice Google Chrome, Firefox o Safari.',

    // Modal.vue
    modal_default_title: '¡Este es el título predeterminado!',
    modal_default_text: '¡Este es el texto predeterminado!',
    modal_default_footer: '¡Este es el pie de página predeterminado!',
    modal_btn_close: 'Cerrar',

    // EditSettingDialog.vue
    edit_setting_title: 'Editar configuración',

    // Enums
    invite_user_default: 'Predeterminado',
    invite_user_invited: 'Invitado',
    invite_user_revoked: 'Revocado',
    invite_user_active: 'Activo',
    invite_user_inactive: 'Inactivo',
    invite_user_suspended: 'Suspendido',

    // Invite Users
    invite_users_to: 'Invitar al usuario a',
    invite_users_title: 'Invitar usuarios',
    invite_users_text: 'Puede invitar a los usuarios a colaborar en su proyecto',
    invite_users_email_placeholder: 'someone@example.com',
    invite_users_btn_add_more: 'Agregar más',
    invite_users_btn_submit: 'Invitar usuarios',

    // Add Organization
    add_org_title: 'Organización',
    add_org_text: 'Esto creará una organización para que pueda invitar a personas a colaborar',
    add_org_name: 'Nombre',
    add_org_domain_name: 'Nombre de dominio',
    add_org_google_analytcs: 'ID de Google Analytics',
    add_org_check_box_login: 'Iniciar sesión en una nueva organización después de la creación',
    add_org_btn_login: 'Iniciar sesión en una nueva organización después de la creación',
    add_org_error_org_exists: 'La organización con ese nombre ya existe',

    // Rename Organization
    rename_org_title: 'Cambiar nombre de organización',
    rename_org_text: 'Renombrar organización seleccionada',
    rename_org_name: 'Nombra tu organización',
    rename_org_placeholder: 'Nombre de la organización',
    rename_org_btn_add: 'Cambiar nombre de organización',
    rename_org_error: 'Error al cambiar el nombre de la organización. Vuelve a intentarlo más tarde. ',
    rename_org_error_forbiden: 'El usuario no tiene los derechos para cambiar el nombre de esta organización',

    // Dialog
    dialog_confirmation: 'Confirmación',
    dialog_are_you_sure: '¿Estás seguro?',
    dialog_yes: 'Sí',
    dialog_no: 'No',
    dialog_ok: 'OK',
    dialog_cancel: 'Cancelar',
    dialog_upload: 'Cargar',
    dialog_upgrade: 'Actualizar',
    dialog_save: 'Guardar',
    dialog_delete_title: 'Confirmar eliminación',
    dialog_delete_text: '¿Está seguro de qué eliminar?',
    dialog_org_admin_title: 'Derechos de administrador de la organización',
    dialog_org_admin_text: '¿Conceder derechos de administrador a la organización del usuario?',
    dialog_org_revoke_admin_text: '¿Revocar los derechos de administrador de la organización de usuarios?',
    dialog_org_revoke_invite_title: 'Revocar invitación',
    dialog_org_resend_invite_title: 'Reenviar invitación',
    dialog_org_suspend_user_title: 'Suspender usuario',
    dialog_org_activate_user_title: 'Activar usuario',

    change_avatar_title: 'Cambiar foto',
    change_avatar_pick_text: 'Elige una foto (Tamaño máximo 512 KB)',
    change_avatar_error: 'La foto es demasiado grande. El tamaño máximo es de 512 KB.',

    // Pagination.vue
    pagination_first: 'Primero',
    pagination_last: 'Último',
    pagination_no_entries: 'No hay entradas coincidentes',
    pagination_previous: 'Página anterior',
    pagination_next: 'Página siguiente',
    pagination_no_entries_hint: 'Prueba a ajustar la búsqueda o los filtros.',


    // SidebarFilter.vue
    sidebar_filter_title: 'Filtro',
    sidebar_filter_tab_facets: 'Facetas',
    sidebar_filter_expand: 'Expandir',
    sidebar_filter_collapse: 'Contraer',

    // AddNameDialog.vue
    add_name_dialog_title: 'Agregar nombre',
    add_name_dialog_subtitle: 'Agregar nombre',
    add_name_dialog_placeholder_name: 'Nombre',
    add_name_dialog_placeholder_description: 'Descripción',
    add_name_dialog_placeholder_payment_provider_id: 'Identificación del proveedor de pago',
    add_name_dialog_button_text: 'Agregar',
}
